export default __webpack_public_path__ + "static/media/logo_dlabs.99d1ffb0.png";